







import BottomPlayer from '@/components/BottomPlayer.vue' // @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { Now } from './models/now'
import { currentProgram, endDate } from './services/now'
import { Poller } from './utils/polling-utils'

class NowPoller extends Poller<Now> {
  callback: { (data: Now): void }

  constructor (callback: { (data: Now): void }) {
    super()
    this.callback = callback
  }

  fetchData (): Promise<Now> {
    return currentProgram()
  }

  didFetchData (data: Now) {
    this.callback(data)
  }

  pollingTimeout (data: Now | null): number | null {
    // Si aucun nouvau programme ou que c'est le même programme, rafraîchir dans 15 secondes
    if (!data || data.date === this.data?.date) {
      return 15000
    }
    // Sinon, rafraîchir à la fin de la chanson
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return endDate(this.data!) - Date.now() + 1000 /// Rajout d'une seconde pour être sûr ne pas rafraîchir trop tôt
  }
}

@Component({
  components: { BottomPlayer }
})
export default class App extends Vue {
  currentProgram: Now | null = null
  nowPoller!: NowPoller

  async mounted () {
    this.nowPoller = new NowPoller((data) => {
      this.currentProgram = data
    })
    this.nowPoller.start()
  }

  beforeUnmount () {
    this.nowPoller.cancel()
  }
}
